import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'autosize-textarea',
  templateUrl: './autosize-textarea.component.html',
  styleUrls: ['./autosize-textarea.component.scss']
})
export class AutosizeTextareaComponent {

  @Input()
  text: any;

  @Input()
  placeholder: any = '';

  @Input()
  size: 'md' | 'sm' | 'lg' = 'md';

  @Input()
  readonly = false;

  @Output()
  textChange = new EventEmitter<any>();
  
  @Input()
  mentionable : any = [];

  @ViewChild('inputControl', { static: false })
  inputControl : ElementRef;

  mentionConfig = {
    triggerChar: '@',
    labelKey: 'FirstName',
    dropUp: true,
    mentionSelect: (item: any) => {
      return item.InsertionValue;
    }
  }

  onTextChange()
  {
    this.textChange.next(this.text);
  }
}
